// extracted by mini-css-extract-plugin
export var copyableField = "_qe-4";
export var customerBadge = "_qe-0";
export var customerInfoTitle = "_qe-2";
export var details = "_qe-1";
export var dropdownContainer = "_qe-5";
export var dropdownImage = "_qe-6";
export var editAssigneeForm = "_qe-a";
export var editButton = "_qe-3";
export var email = "_qe-7";
export var hidden = "_qe-d";
export var input = "_qe-8";
export var saveButton = "_qe-b";
export var shopifyIcon = "_qe-c";
export var suggestionBadge = "_qe-e";
export var suggestionText = "_qe-f";
export var username = "_qe-9";